export default __webpack_public_path__ + "static/media/mailbluster.cb882e3c.png";